import { EmptyState } from '@mint-lib/tw-components/patterns';

function NoData() {
  return (
    <EmptyState
      size="medium"
      title="No data."
      description="This action link isn't valid."
      illustration="IllustrationEmptyState"
    />
  );
}

export default NoData;
